export const checkIsSuperAdmin = (userStore) => userStore?.role_attributes?.attributes?.code === 'admin';

export const formatPrivilegesToString = (newPrivileges) => newPrivileges.map((item) => item?.privilege_attributes?.attributes?.code);
